import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import CertificateCategoryTable from '@certificates/components/tables/certificate-category-table/certificate-category-table.vue';

@Component({
  name: 'bpc-certificate-categories',
  components: {
    'bpc-certificate-categories-table': CertificateCategoryTable,
  },
})
export default class CertficateCategories extends Vue {
  /* Lifecycle hooks */
  // created() {}
  // mounted() {}
  // updated() {}
  // destroyed() {}
}
